import { Injector } from '@angular/core';
import { lazyLoadCheckoutFacade } from '@lentau/order/checkout-by-step/store/checkout-by-step.loader';
import { MethodError } from '@lentau/core/api/application';

export const handleCheckoutApiError = async (error: MethodError, injector: Injector): Promise<string> => {
  try {
    const checkoutFacade = await lazyLoadCheckoutFacade(injector);
    const pageName: string =
      checkoutFacade.currentStep() < 3 ? `checkout_step_${checkoutFacade.currentStep() + 1}` : 'checkout';

    return pageName;
  } catch (err: unknown) {
    console.error('Failed to load CheckoutByStepFacade:', err);
  }
};
